export default __webpack_public_path__ + "static/media/logo.10b0caad.png";